import { getContext, put, call, select, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux';
import { ApolloError } from 'apollo-client';
import { FormAction as BaseFormAction, SubmissionError } from 'redux-form';
import { Services } from 'init/services';
import { getFormErrors } from '../../../../utils/formatError';
import { getClientId } from '../../../../utils/clientId';
import { metadataSelector } from 'selectors/app';
import { getUtClientId } from 'libs/cookie';
import { SagaContext } from '../../../../types/common';
import { sessionId } from '../../selectors';
import { routine, actions } from './actions';
import { FormData } from './constraints';
import { Props } from './index';
import * as mutation from './mutation.gql';
import { RegistrationFirstStepVariables } from './__generated__/RegistrationFirstStep';

interface FormAction extends BaseFormAction {
  payload: {
    values: FormData;
    props: Props;
  };
}

// @translate
type Errors =
  | 'email already used'
  | 'Phone is invalid'
  | 'Forbidden country for registration {country}';

export default function* saga(next: Action) {
  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  yield takeEvery(routine.TRIGGER, function* ({ payload: { props, values } }: FormAction) {
    const url = window.location.href.split('?')[0];

    const { email, phone, firstName, lastName } = values;

    const variables: RegistrationFirstStepVariables = {
      sessionId: yield select(sessionId),
      type: 'USER',
      landing: `${url}#${props.landing}`,
      metadata: {
        ...(yield select(metadataSelector)),
        url,
        form: props.landing,
      },
      clientId: getUtClientId(),
      gaId: yield getClientId(),
      email: email.trim(),
      phone: phone.trim(),
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    };

    try {
      yield call(apolloClient.mutate, { mutation, variables });

      yield put(routine.success());
      yield put(actions.save(email, phone, firstName));

      yield put(next);
    } catch (e: ApolloError | any) {
      const errors = getFormErrors(e);
      yield put(routine.failure(new SubmissionError<FormData, Errors>(errors)));
    }
  });
}
